export default __webpack_public_path__ + "static/media/indian_flag.3b9cb3aa.svg";